import { types } from './questionType'

export const firstFlow = [
	{
		id: '0',
		componentType: types.TEXT_ANSWERS,
		question: 'What do you prefer more?',
		answers: [
			{ answer: 'Deal with video/ GIF', emoji: 'photo-camera' },
			{ answer: 'Process photos', emoji: 'movie-camera' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '1',
		componentType: types.TEXT_ANSWERS,
		question: 'What do you love about photo editing?',
		answers: [
			{ answer: 'Automatisation', emoji: 'sunglasses' },
			{ answer: 'Creativity', emoji: 'smirking' },
			{ answer: 'Experiments', emoji: 'nerd' },
			{ answer: 'Changes', emoji: 'star-struck' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '2',
		componentType: types.CIRCLES_ANSWERS,
		question: 'Where will you share your photos or videos the most?',
		answers: [
			'Instagram',
			'YouTube',
			'Tiktok',
			'Snapchat',
			'Facebook',
			'Twitter',
		],
		selected: [],
		buttonText: 'Next',
		skipable: false,
		isMultiple: true,
	},
]

export const secondFlow = [
	{
		id: '0',
		componentType: types.WITHOUT_EMOJI_TEXT_ANSWERS,
		question: 'What is your age?',
		answers: ['20s', '30s', '35+'],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '1',
		componentType: types.MEDIA_ANSWERS,
		question: "Have you lately caught the bride's bouquet?",
		answers: ["No, I haven't", 'Of course, recently'],
		selected: -1,
		video: 'bride',
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '2',
		componentType: types.TEXT_ANSWERS,
		question: 'Have you been poured with champagne or wine?',
		answers: [
			{ answer: 'Certainly, not!', emoji: 'sunglasses' },
			{ answer: 'Can I say Yes if I did on my own?', emoji: 'smirking' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '3',
		componentType: types.TEXT_ANSWERS,
		question:
			'How long should you be in relationships to think about getting married?',
		answers: [
			{ answer: 'More than 1 year', emoji: 'sunglasses' },
			{ answer: 'Less than 1 year', emoji: 'smirking' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '4',
		componentType: types.TEXT_ANSWERS,
		question: "Now let's talk about your temper. Are you jealous?",
		answers: [
			{ answer: 'Absolutely not', emoji: 'sunglasses' },
			{ answer: 'This is my only drawback', emoji: 'silence' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '5',
		componentType: types.TEXT_ANSWERS,
		question: 'Would you like to have a gold engagement ring or a diamond? ',
		answers: [
			{ answer: 'I choose minimalistic gold', emoji: 'sunglasses' },
			{ answer: 'I need the biggest diamond', emoji: 'smirking' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '6',
		componentType: types.TEXT_ANSWERS,
		question: 'What’s your relationship status?',
		answers: [
			{ answer: 'Single', emoji: 'sunglasses' },
			{ answer: 'In a relationship', emoji: 'smirking' },
			{ answer: "It's a complicated", emoji: 'silence' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
]

export const thirdFlow = [
	{
		id: '0',
		componentType: types.WITHOUT_EMOJI_TEXT_ANSWERS,
		question: 'What is your age?',
		answers: ['20s', '30s', '35+'],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '1',
		componentType: types.WITHOUT_EMOJI_TEXT_ANSWERS,
		question: 'How old were your parents when you were born?',
		answers: ['18-21', '22-25', '25-35', '35+'],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '2',
		componentType: types.IMAGE_ANSWERS,
		question: 'Which celebrity mom do you connect with the most?',
		answers: ['Hillary Duff', 'Taylor Swift', 'Angelina Jolie', 'Mila Kunis'],
		selected: [],
		buttonText: 'Next',
		prediction: true,
		skipable: false,
		isMultiple: true,
	},
	{
		id: '3',
		componentType: types.MEDIA_ANSWERS,
		question: 'Do you come from a big family?',
		answers: ['Yes', 'No'],
		image: 'family',
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '4',
		componentType: types.TEXT_ANSWERS,
		question: 'How much free time do you usually have during the week?',
		answers: [
			{ answer: 'My schedule is completely open', emoji: 'sunglasses' },
			{ answer: 'I definitely find time for “me time”', emoji: 'smirking' },
			{ answer: "Barely any. I'm super busy", emoji: 'nerd' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '5',
		componentType: types.TEXT_ANSWERS,
		question: 'When is last time you held a baby?',
		answers: [
			{ answer: 'I’ve never held a baby before', emoji: 'silence' },
			{ answer: 'Years ago', emoji: 'blush' },
			{ answer: 'Recently', emoji: 'smirking' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '6',
		componentType: types.MEDIA_ANSWERS,
		question: 'Had you chosen, would you firstly get girl or boy?',
		answers: ['Boy', 'Girl'],
		selected: -1,
		video: 'boy-girl',
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '7',
		componentType: types.MEDIA_ANSWERS,
		question: 'Are you a patient person?',
		answers: ['Yes', 'No'],
		selected: -1,
		image: 'patience',
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '8',
		componentType: types.TEXT_ANSWERS,
		question: 'What’s your relationship status?',
		answers: [
			{ answer: 'Single', emoji: 'smirking' },
			{ answer: 'Married', emoji: 'blush' },
			{ answer: 'In a relationship', emoji: 'smirking' },
			{ answer: "It's a complicated", emoji: 'silence' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '9',
		componentType: types.MEDIA_ANSWERS,
		question: 'Do you care about finances before having kids?',
		answers: ['Yes', 'No'],
		selected: -1,
		image: 'keys',
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
]

export const cartoonifyFlow = [
	{
		id: '0',
		componentType: types.TEXT_ANSWERS,
		question: 'What do you prefer more?',
		answers: [
			{ answer: 'Retouch portraits', emoji: 'pen' },
			{ answer: 'Use face masks', emoji: 'girl' },
		],
		selected: -1,
		buttonText: '',
		skipable: false,
		isMultiple: false,
	},
	{
		id: '1',
		componentType: types.IMAGE_ANSWERS,
		question: 'Which animated movie character style you like the most?',
		answers: [0, 1, 2, 3],
		selected: [],
		buttonText: 'Next',
		skipable: false,
		isMultiple: true,
	},
	{
		id: '2',
		componentType: types.CIRCLES_ANSWERS,
		question: 'Choose your favorite animated movies:',
		answers: [
			'The Lion King',
			'Up',
			'WALL-E',
			'The Boss Baby',
			'Frozen',
			'Shrek',
		],
		selected: [],
		buttonText: 'Next',
		skipable: false,
		isMultiple: true,
	},
]
